export default __webpack_public_path__ + "static/assets/6fe9f9f6e7c071455bb64f2932ebfdfc.gif";